import { render, staticRenderFns } from "./CheckMoreText.vue?vue&type=template&id=1bc1215b&scoped=true&"
import script from "./CheckMoreText.vue?vue&type=script&lang=js&"
export * from "./CheckMoreText.vue?vue&type=script&lang=js&"
import style0 from "./CheckMoreText.vue?vue&type=style&index=0&id=1bc1215b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1215b",
  null
  
)

export default component.exports